import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId, FlowTypes, urlMapper } from '@shared/models';
import { InvestmentStrategyContent } from '@shared/services/content/content-jsons/open-choice/investment-strategy.content';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import { rejectDAOffer } from '@store/actions/open-choice/open-choice.actions';
import * as fromRootStore from '@store/index';
import { getFlowTypeSelection } from '@store/reducers/triage/triage.reducer';
import { from } from 'rxjs';

@Component({
  selector: 'app-investment-strategy',
  templateUrl: './investment-strategy.component.html',
  styleUrl: './investment-strategy.component.scss',
})
export class InvestmentStrategyComponent extends PageComponent implements OnInit, OnDestroy {
  content = InvestmentStrategyContent;
  openChoiceCommonContent = OpenChoiceCommonContent;

  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.investmentstrategy, globalStore);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onContinueAsDA() {
    this.globalStore.dispatch(
      fromRootStore.TrackProcessSideStep({
        processType: 'coo-minor-flow',
        processSideStep: 'coo-minor-gc-investment_strategy-all_index',
      }),
    );

    this.globalStore.dispatch(fromRootStore.Next());
  }

  onContinueWithoutDA(investmentStrategy: string): void {
    this.globalStore.dispatch(
      fromRootStore.TrackCallToAction({
        location: 'coo-minor-gc-investment_strategy',
        ctaName: `coo-minor-gc-investment_strategy-${investmentStrategy.toLocaleLowerCase()}`,
        ctaType: 'button',
      }),
    );

    this.globalStore.dispatch(rejectDAOffer());
    this.globalStore.dispatch(fromRootStore.Next());
  }
}
